import { action } from 'typesafe-actions';
import { CLOActionTypes } from 'types';

export const fetchTopThreeCLO = (request?: any) =>
  action(CLOActionTypes.FETCH_TOP_THREE_CLO_START, request);
export const fetchTopThreeCLOSuccess = (data: any) =>
  action(CLOActionTypes.FETCH_TOP_THREE_CLO_SUCCESS, data);
export const fetchTopThreeCLOFailure = (error: any) =>
  action(CLOActionTypes.FETCH_TOP_THREE_CLO_FAILURE, error);

export const fetchCLOListing = (request?: any) =>
  action(CLOActionTypes.FETCH_CLO_LISTING_START, request);
export const fetchCLOListingSuccess = (request?: any) =>
  action(CLOActionTypes.FETCH_CLO_LISTING_SUCCESS, request);
export const fetchCLOListingFailure = (request?: any) =>
  action(CLOActionTypes.FETCH_CLO_LISTING_FAILURE, request);

export const fetchCLODetails = (request?: any) =>
  action(CLOActionTypes.FETCH_CLO_DETAILS_START, request);
export const fetchCLODetailsSuccess = (request?: any) =>
  action(CLOActionTypes.FETCH_CLO_DETAILS_SUCCESS, request);
export const fetchCLODetailsFailure = (request?: any) =>
  action(CLOActionTypes.FETCH_CLO_DETAILS_FAILURE, request);

export const addCLOEvent = (request?: any) =>
  action(CLOActionTypes.ADD_CLO_EVENT_START, request);
export const addCLOEventSuccess = (request?: any) =>
  action(CLOActionTypes.ADD_CLO_EVENT_SUCCESS, request);
export const addCLOEventFailure = (request?: any) =>
  action(CLOActionTypes.ADD_CLO_EVENT_FAILURE, request);

export const addCLOAsFavourite = (request?: any) =>
  action(CLOActionTypes.ADD_CLO_AS_FAVOURITE_START, request);
export const addCLOAsFavouriteSuccess = (request?: any) =>
  action(CLOActionTypes.ADD_CLO_AS_FAVOURITE_SUCCESS, request);
export const addCLOAsFavouriteFailure = (request?: any) =>
  action(CLOActionTypes.ADD_CLO_AS_FAVOURITE_FAILURE, request);

export const removeCLOAsFavourite = (request?: any) =>
  action(CLOActionTypes.REMOVE_CLO_AS_FAVOURITE_START, request);
export const removeCLOAsFavouriteSuccess = (request?: any) =>
  action(CLOActionTypes.REMOVE_CLO_AS_FAVOURITE_SUCCESS, request);
export const removeCLOAsFavouriteFailure = (request?: any) =>
  action(CLOActionTypes.REMOVE_CLO_AS_FAVOURITE_FAILURE, request);

export const hideCLO = (request?: any) =>
  action(CLOActionTypes.HIDE_CLO_START, request);
export const hideCLOSuccess = (request?: any) =>
  action(CLOActionTypes.HIDE_CLO_SUCCESS, request);
export const hideCLOFailure = (request?: any) =>
  action(CLOActionTypes.HIDE_CLO_FAILURE, request);

export const unhideCLO = (request?: any) =>
  action(CLOActionTypes.UNHIDE_CLO_START, request);
export const unhideCLOSuccess = (request?: any) =>
  action(CLOActionTypes.UNHIDE_CLO_SUCCESS, request);
export const unhideCLOFailure = (request?: any) =>
  action(CLOActionTypes.UNHIDE_CLO_FAILURE, request);
export const refreshTopThreeCLO = (request?: any) =>
  action(CLOActionTypes.REFRESH_TOP_THREE_CLO_START, request);
